const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1025 1024",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-6,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1",
    transform: "matrix(1,0,0,1,6.80635,1.13687e-13)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1024,
    height: 1024,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 512,
    r: 512,
    style: {
      fill: "rgb(186,150,73)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.2434,0.360742,-0.360742,1.2434,90.9267,-408.716)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.904295,0,0,0.904295,-926.425,128.073)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1585.95,697.112C1586.68,699.645 1589,701.388 1591.64,701.388C1594.28,701.388 1596.6,699.645 1597.34,697.112C1604.11,675.38 1615.83,654.36 1633.61,633.862C1667.85,594.375 1720.05,571.066 1765.62,533.14C1769.13,530.095 1774.1,529.395 1778.32,531.354C1782.53,533.313 1785.2,537.564 1785.13,542.21C1784.34,620.618 1779.45,681.161 1726.07,718.268C1688.39,744.459 1674.4,751.192 1635.72,761.777C1628.6,763.759 1623.02,768.9 1620.32,775.432L1620.32,864.164C1620.32,879.513 1607.88,891.956 1592.53,891.956L1591.64,891.942L1590.75,891.956C1575.4,891.956 1562.96,879.513 1562.96,864.164L1562.96,775.432C1560.27,768.9 1554.68,763.759 1547.56,761.777C1508.88,751.192 1494.89,744.459 1457.21,718.268C1403.83,681.161 1398.94,620.618 1398.15,542.21C1398.08,537.564 1400.75,533.313 1404.96,531.354C1409.18,529.395 1414.15,530.095 1417.66,533.14C1463.24,571.066 1515.43,594.375 1549.67,633.862C1567.45,654.36 1579.17,675.38 1585.95,697.112Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,160)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.02463,0,0,1.02463,-1139.67,-4.53223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1462.98,260.216C1459.48,257.884 1455.01,257.584 1451.23,259.429C1447.45,261.274 1444.93,264.985 1444.62,269.179C1442.04,307.258 1447.39,360.456 1475.36,377.888C1507.24,397.762 1532.87,429.676 1576.47,440.53C1579.99,441.417 1584.72,441.64 1587.59,439.424C1590.46,437.207 1591.16,432.794 1591.19,429.166C1591.07,397.161 1564.44,344.174 1542.21,318.176C1519.49,291.598 1493.03,280.114 1462.98,260.216Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.02463,0,0,1.02463,-1096.25,-4.53223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1720.3,260.216C1723.8,257.884 1728.28,257.584 1732.05,259.429C1735.83,261.274 1738.35,264.985 1738.66,269.179C1741.24,307.258 1735.89,360.456 1707.92,377.888C1676.04,397.762 1650.42,429.676 1606.81,440.53C1603.29,441.417 1598.56,441.64 1595.69,439.424C1592.82,437.207 1592.12,432.794 1592.09,429.166C1592.21,397.161 1618.84,344.174 1641.07,318.176C1663.79,291.598 1690.25,280.114 1720.3,260.216Z",
    style: {
      fill: "white"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.06682,0,0,1.06682,-1185.1,117.974)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1583.42,137.52C1588.2,133.599 1595.08,133.598 1599.87,137.519C1625.07,158.353 1641.07,187.035 1641.07,222.701C1641.07,258.311 1625.12,290.224 1599.99,311.678C1595.16,315.738 1588.12,315.738 1583.3,311.679C1558.16,290.224 1542.21,258.311 1542.21,222.701C1542.21,187.035 1558.21,158.353 1583.42,137.52Z",
    style: {
      fill: "white"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.e9e3bf61483296db2a361ef3739bb0d2.svg";
export { ForwardRef as ReactComponent };